export const iconFontAwesomeAutomotiveCaravan = (
	<i className="fa-solid fa-caravan"></i>
);
